import axios from "axios";
import Config from "../../config/";
import moment from "moment";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;


export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token")}
  };
}

export function pushUpload(file_title, fileurl) {
  const url = `${ROOT_URL}datasets/datasets/`;

  const fdata = new FormData();
  fdata.append("file_title", file_title);
  fdata.append("dataseturl", fileurl);
  fdata.append("author", localStorage.getItem("name"));
  fdata.append("date_created", moment().format("YYYY-MM-DD"));
  fdata.append("price", 0);
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("downloaded", 0);
  fdata.append("stars", 0);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushUploadGlob(file_title, fileurl) {
  const url = `${ROOT_URL}datasetsglob/datasetsglob/`;

  const fdata = new FormData();
  fdata.append("file_title", file_title);
  fdata.append("dataseturl", fileurl);
  fdata.append("author", localStorage.getItem("name"));
  fdata.append("date_created", moment().format("YYYY-MM-DD"));
  fdata.append("price", 0);
  fdata.append("user_id", localStorage.getItem("id"));
  fdata.append("downloaded", 0);
  fdata.append("stars", 0);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
export function proccessUpload(fileupload, ext) {
  const url = `${ROOT_URL}datasets/datasetapi/`;

  const fdata = new FormData();
  fdata.append("fileupload", fileupload);
  fdata.append("ext", ext);

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function fetchDataTable() {
  const url = `${ROOT_URL}datasets/datasets/`;

  const fdata = new FormData();
  fdata.append("limit", 10);

  const request = axios.get(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushUpdateStars(stars, datanya) {

  console.log(datanya);
  const url = `${ROOT_URL}datasets/datasets/${datanya[0]}/`;

  const fdata = new FormData();
  fdata.append("author", datanya[1]);
  fdata.append("dataseturl", datanya[8]);
  fdata.append("date_created", datanya[7]);
  fdata.append("price", datanya[4]);
  fdata.append("stars", stars);
  fdata.append("user_id", datanya[6]);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushUpdateStarsGlob(stars, datanya) {
  console.log(datanya);
  const url = `${ROOT_URL}datasetsglob/datasetsglob/${datanya[0]}/`;

  const fdata = new FormData();
  fdata.append("author", datanya[1]);
  fdata.append("dataseturl", datanya[8]);
  fdata.append("date_created", datanya[7]);
  fdata.append("price", datanya[4]);
  fdata.append("stars", stars);
  fdata.append("user_id", datanya[6]);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}
